import { z } from "zod";

const addressSchema = z.object({
  addressLineOne: z.string().min(1, { message: "Address is required" }),
  addressLineTwo: z.string().optional(),
  city: z.string().min(1, { message: "City is required " }),
  state: z.string().min(1, { message: "Please select a state" }),
  zipCode: z.string().regex(/^\d{5}$/, "ZIP Code must be a 5-digit number"),
});

export const addressInformationSchema = z.object({
  cellPhoneNumber: z
    .string()
    .length(10, { message: "Cell phone must be a 10-digit number" }),
  billingAddress: addressSchema,
  shippingAddress: addressSchema.optional(),
  hasSameShippingAddress: z.enum(["yes", "no"], {
    required_error: "Please select an option",
  }),
});

export type AddressInformationFormType = z.infer<
  typeof addressInformationSchema
>;
